import 'core-js/stable';
import 'regenerator-runtime/runtime';
import jQuery from 'jquery';
import 'bootstrap';
import Raven from 'raven-js';

import EasyPostConstants from './easypost_constants';

import trackerSuccess from './tracker_success';


const $ = jQuery;

Raven.config(EasyPostConstants.RavenUrl).install();

$(() => {
  const FEJS = {
    trackerSuccess,
    initialize: () => {
      const page = $('body').data('jspage');
      if (typeof page !== 'undefined' && Object.prototype.hasOwnProperty.call(FEJS, page)) {
        FEJS[page]();
      }
    },
  };
  Raven.context(() => FEJS.initialize());
});
